export default __webpack_public_path__ + "static/media/icon-instagram.54d3962e.svg";